import {ReactElement} from "react"
import {useRouteLoaderData} from "react-router-dom";
import {Code} from "../Services/Steam/Code";
import {IPosition} from "../../interfaces/position.interface";

export function Activation(): ReactElement | null {
  const item = useRouteLoaderData("activation") as IPosition;

  switch (item.type.key) {
    case 'service':
      switch (item.service?.key) {
        case 'steam':
          switch (item.service?.method.key) {
            case 'replenishment':
              return <Code />;
          }
      }
      break;
  }

  return null;
}
